import { render, staticRenderFns } from "./TableRiskAppraisal595.vue?vue&type=template&id=52adef9a&scoped=true&"
import script from "./TableRiskAppraisal595.vue?vue&type=script&lang=js&"
export * from "./TableRiskAppraisal595.vue?vue&type=script&lang=js&"
import style0 from "./TableRiskAppraisal595.vue?vue&type=style&index=0&id=52adef9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52adef9a",
  null
  
)

export default component.exports